import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root'
})

@Injectable()
export class RoleGuardService implements CanActivate {
  constructor(private authService: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRoles = route?.data?.expectedRoles;

    if(expectedRoles === undefined || expectedRoles.length === 0) {
        // No roles defined, allow access
        return true;
    }

    const res = this.authService.isInRole(expectedRoles);
    return res;
  }
}
